import React, { useState, useEffect } from 'react';

const NavBar = () => {
    const [isActive, setIsActive] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState('home');

    const handleMenuToggle = () => {
        setIsActive(!isActive);
    };

    const handleLinkClick = (sectionId) => {
        setActiveSection(sectionId);
        setIsActive(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 40) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }

            // Scroll-spy calculation
            const sections = ['home', 'about', 'facility', 'menu', 'gallery', 'reviews', 'contact'];
            const scrollPosition = window.scrollY + 180;

            for (const section of sections) {
                const el = document.getElementById(section);
                if (el) {
                    const top = el.offsetTop;
                    const height = el.offsetHeight;
                    if (scrollPosition >= top && scrollPosition < top + height) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="header-container">
                <a href="#home" className="logo-wrapper" onClick={() => handleLinkClick('home')}>
                    <img src="/images/iconCafe9-removebg-preview.png" alt="Café 9 Phước Hải Logo" />
                    <div className="logo-text">
                        <span className="logo-title">Café <span>9</span></span>
                        <span className="logo-subtitle">Phước Hải • Est. 1983</span>
                    </div>
                </a>

                <nav className={`navbar ${isActive ? 'active' : ''}`}>
                    <a
                        href="#home"
                        className={activeSection === 'home' ? 'active' : ''}
                        onClick={() => handleLinkClick('home')}
                    >
                        Trang Chủ
                    </a>
                    <a
                        href="#about"
                        className={activeSection === 'about' ? 'active' : ''}
                        onClick={() => handleLinkClick('about')}
                    >
                        Câu Chuyện 1983
                    </a>
                    <a
                        href="#facility"
                        className={activeSection === 'facility' ? 'active' : ''}
                        onClick={() => handleLinkClick('facility')}
                    >
                        Đặc Trưng
                    </a>
                    <a
                        href="#menu"
                        className={activeSection === 'menu' ? 'active' : ''}
                        onClick={() => handleLinkClick('menu')}
                    >
                        Thực Đơn
                    </a>
                    <a
                        href="#gallery"
                        className={activeSection === 'gallery' ? 'active' : ''}
                        onClick={() => handleLinkClick('gallery')}
                    >
                        Hình Ảnh
                    </a>
                    <a
                        href="#reviews"
                        className={activeSection === 'reviews' ? 'active' : ''}
                        onClick={() => handleLinkClick('reviews')}
                    >
                        Đánh Giá
                    </a>
                    <a
                        href="#contact"
                        className={activeSection === 'contact' ? 'active' : ''}
                        onClick={() => handleLinkClick('contact')}
                    >
                        Vị Trí & Liên Hệ
                    </a>
                </nav>

                <div className="header-actions">
                    <a href="tel:02543886336" className="nav-phone-btn">
                        <i className="fas fa-phone-alt"></i>
                        <span>02543 886 336</span>
                    </a>
                    <div
                        id="menu-btn"
                        className={`fas ${isActive ? 'fa-times' : 'fa-bars'}`}
                        onClick={handleMenuToggle}
                        aria-label="Toggle navigation menu"
                    ></div>
                </div>
            </div>
        </header>
    );
};

export default NavBar;